import { Environment } from 'src/Environment';
import { appDynamicsUserIdKey } from 'src/services/user.service';

type UserData = {
  userData: {
    userID: string;
  }
}

type Info = {
  Ajax: () => UserData;
  PageView: () => UserData;
  VPageView: () => UserData;
}

class WebAppDynamics {
  webAppDynamicsEnabled = !Environment.current.disabledFeatures.webAppDynamics;

  _initialize() {
    window['adrum-start-time'] = new Date().getTime();
    window['adrum-config'] = {
      ...Environment.current.webAppDynamicsConfig,
    };
  }

  extractUserData(info: Info, userId: string) {
    info.Ajax = () => ({
      userData: {
        userID: userId
      }
    })

    info.PageView = () => ({
      userData: {
        userID: userId
      }
    })

    info.VPageView = () => ({
      userData: {
        userID: userId
      }
    })
  }

  run() {
    if (this.webAppDynamicsEnabled) {
      const userId = sessionStorage.getItem(appDynamicsUserIdKey) || "user ID not available";
      const script = document.createElement('script');
      script.src = '//cdn.appdynamics.com/adrum/adrum-latest.js';
      script.id = 'appDynamics';
      document.body.appendChild(script);

      this._initialize();

      if (!window['adrum-config']?.userEventInfo) {
        window['adrum-config'].userEventInfo = {};
      }

      this.extractUserData(window['adrum-config']?.userEventInfo || {}, userId);
    }
  }
}

export const webAppDynamicsObject = new WebAppDynamics();
